import { ReactElement, useCallback, useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

import { Page, CrudMode } from '@ohpen/enso-ui';
import { ConfirmCrDeleteModal, ErcProfilesCrudForm, ErcProfilesList } from '@pmp/components';
import { ErcProfile, ercProfilesCreateDeleteCr, ercProfilesValidateDelete } from '@pmp/api';
import { usePmpFetch } from '@pmp/hooks';

import { initialState, reducer } from './reducer';

export const ErcProfilesPage = (): ReactElement => {
  const [isFetching, , data, , fetchData] = usePmpFetch('ercProfilesGetAllErcProfiles');
  const [state, dispatch] = useReducer(reducer, initialState);
  const { t } = useTranslation();

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onCreate = useCallback(() => {
    dispatch({ type: 'openCrud', record: null, mode: CrudMode.CREATE });
  }, []);

  const onView = useCallback((record: ErcProfile) => {
    dispatch({ type: 'openCrud', record, mode: CrudMode.VIEW });
  }, []);

  const onEdit = useCallback((record: ErcProfile) => {
    dispatch({ type: 'openCrud', record, mode: CrudMode.EDIT });
  }, []);

  const onCloseCrud = useCallback(() => {
    dispatch({ type: 'closeCrud' });
  }, []);

  const onDelete = useCallback((record: ErcProfile) => {
    dispatch({ type: 'openDeleteModal', record });
  }, []);

  const onCloseDeleteModal = useCallback(() => {
    dispatch({ type: 'closeDeleteModal' });
  }, []);

  return (
    <Page>
      <Page.Title>{t('pmp.erc.title')}</Page.Title>
      <Page.Content>
        <ErcProfilesList
          isFetching={isFetching}
          data={data ?? []}
          onCreate={onCreate}
          onView={onView}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        {state.crud.open && state.crud.mode && (
          <ErcProfilesCrudForm mode={state.crud.mode} record={state.crud.record} refreshTable={fetchData} onClose={onCloseCrud} />
        )}
      </Page.Content>
      <ConfirmCrDeleteModal
        open={state.deleteModal.open}
        records={state.deleteModal.record ? [state.deleteModal.record] : []}
        idKey="ercProfileId"
        nameKey="name"
        entityLabel={t('pmp.erc.labels.ercProfile')}
        entityLabelPlural={t('pmp.erc.labels.ercProfiles')}
        getPrecheck={ercProfilesValidateDelete}
        createDeleteChangeRequest={ercProfilesCreateDeleteCr}
        refreshTable={fetchData}
        onClose={onCloseDeleteModal}
      />
    </Page>
  );
};
